/* eslint-disable @typescript-eslint/naming-convention */
import { QUOTE_CONTEXTS } from '@bytel/checkout';

import { REINSURANCE_CHOICES } from '@base/common/constants/index';

export const translations = {
    titles: {
        [QUOTE_CONTEXTS.ACQUISITION]: {
            label: 'Mon offre mobile',
        },
        [QUOTE_CONTEXTS.RENEW]: {
            label: 'Valider mon changement de mobile',
        },
        [QUOTE_CONTEXTS.ACQUISITIONFIX]: {
            label: 'Mon offre fixe',
        },
    },
    reinsurance: {
        [REINSURANCE_CHOICES.FREE_SHIPPING]: {
            label: 'Livraison offerte en Relais Colis',
            subtitle: '(sauf carte sim seule)',
        },
        [REINSURANCE_CHOICES.PROMOTIONS]: {
            label: 'Promotions exclusives',
        },
        [REINSURANCE_CHOICES.SECURE_PAYMENT]: {
            label: 'Paiement sécurisé',
        },
        [REINSURANCE_CHOICES.CUSTOMER_SERVICE]: {
            label: 'Un service client disponible',
        },
        [REINSURANCE_CHOICES.TERMINATION_FEES]: {
            label: "Frais de résiliation remboursés jusqu'à 50€",
        },
        [REINSURANCE_CHOICES.NO_COMMITMENT]: {
            label: 'Offre sans engagement',
        },
        [REINSURANCE_CHOICES.NETWORK_4G]: {
            label: 'La qualité du réseau',
        },
        [REINSURANCE_CHOICES.CHECKED_REVIEW]: {
            label: 'Avis vérifiés',
        },
    },
    bonusLabel: {
        1: {
            'panier.forfait.bonus.titre.un_bonus': {
                label: '1 bonus au choix',
            },
        },
        2: {
            'panier.forfait.bonus.titre.tous_les_bonus': {
                label: 'Tous les bonus inclus au choix',
            },
        },
    },
};
